import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faCalendar as farCalendar,
  faCamera as farCamera,
  faCameraRetro as farCameraRetro,
  faCartShopping as farCartShopping,
  faCircle as farCircle,
  faCircleDot as farCircleDot,
  faCircleHeart as farCircleHeart,
  faCircleInfo as farCircleInfo,
  faCopy as farCopy,
  faSchool as farSchool,
  faSquare as farSquare,
  faTableList as farTableList,
  faTriangleExclamation as farTriangleExclamation,
  faUser as farUser
} from '@fortawesome/pro-regular-svg-icons'
import {
  fa1,
  fa2,
  fa3,
  faArrowLeft,
  faArrowUpRightFromSquare,
  faBan,
  faBars,
  faCalendarDays,
  faCamera,
  faCheck,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronsDown,
  faChevronsUp,
  faChevronUp,
  faCircle1,
  faCircle2,
  faCircle3,
  faCircle4,
  faCircle5,
  faCircleArrowDown,
  faCircleArrowLeft,
  faCircleArrowRight,
  faCircleArrowUp,
  faCircleCheck,
  faCircleExclamation,
  faCircleInfo,
  faCirclePlay,
  faClock,
  faComment,
  faDownload,
  faEnvelope,
  faEye,
  faEyeSlash,
  faGlobe,
  faGrid,
  faHeart,
  faHouse,
  faImage,
  faLocationDot,
  faLock,
  faMessage,
  faMinus,
  faPhone,
  faPlus,
  faPrint,
  faSparkles,
  faSpinner,
  faSquareCheck,
  faSquarePlus,
  faStar,
  faTimes,
  faTriangleExclamation,
  faUpload,
  faUser,
  faXmark
} from '@fortawesome/pro-solid-svg-icons'

export const iconIds = {
  faArrowLeft: ['fas', 'arrow-left'],
  faArrowUpRightFromSquare: ['fas', 'arrow-up-right-from-square'],
  fa1: ['fas', '1'],
  fa2: ['fas', '2'],
  fa3: ['fas', '3'],
  faBan: ['fas', 'ban'],
  faBars: ['fas', 'bars'],
  fasCamera: ['fas', 'camera'],
  faCalendarDays: ['fas', 'calendar-days'],
  faCamera: ['far', 'camera'],
  faCheck: ['fas', 'check'],
  faCircle1: ['fas', 'circle-1'],
  faCircle2: ['fas', 'circle-2'],
  faCircle3: ['fas', 'circle-3'],
  faCircle4: ['fas', 'circle-4'],
  faCircle5: ['fas', 'circle-5'],
  faCircleCheck: ['fas', 'circle-check'],
  faCircleArrowDown: ['fas', 'circle-arrow-down'],
  faCircleArrowUp: ['fas', 'circle-arrow-up'],
  faDownload: ['fas', 'download'],
  faEye: ['fas', 'eye'],
  faEyeSlash: ['fas', 'eye-slash'],
  faChevronDown: ['fas', 'chevron-down'],
  faChevronLeft: ['fas', 'chevron-left'],
  faChevronRight: ['fas', 'chevron-right'],
  faChevronsDown: ['fas', 'chevrons-down'],
  faChevronsUp: ['fas', 'chevrons-up'],
  faChevronUp: ['fas', 'chevron-up'],
  faCircleArrowLeft: ['fas', 'circle-arrow-left'],
  faCircleArrowRight: ['fas', 'circle-arrow-right'],
  faCircleExclamation: ['fas', 'circle-exclamation'],
  faCirclePlay: ['fas', 'circle-play'],
  faComment: ['fas', 'comment'],
  faCircleInfo: ['fas', 'circle-info'],
  faClock: ['fas', 'clock'],
  faEnvelope: ['fas', 'envelope'],
  faGlobe: ['fas', 'globe'],
  faGrid: ['fas', 'grid'],
  faHeart: ['fas', 'heart'],
  faHouse: ['fas', 'house'],
  faImage: ['fas', 'image'],
  faLocationDot: ['fas', 'location-dot'],
  faLock: ['fas', 'lock'],
  faMessage: ['fas', 'message'],
  faMinus: ['fas', 'minus'],
  faPhone: ['fas', 'phone'],
  faPlus: ['fas', 'plus'],
  faPrint: ['fas', 'print'],
  faSparkles: ['fas', 'sparkles'],
  faSpinner: ['fas', 'spinner'],
  faStar: ['fas', 'star'],
  faSquareCheck: ['fas', 'square-check'],
  faSquarePlus: ['fas', 'square-plus'],
  faTimes: ['fas', 'times'],
  faTriangleExclamation: ['fas', 'triangle-exclamation'],
  faUpload: ['fas', 'upload'],
  faUser: ['fas', 'user'],
  faXmark: ['fas', 'xmark'],
  farCopy: ['far', 'copy'],
  farCircle: ['far', 'circle'],
  farCircleDot: ['far', 'circle-dot'],
  farCalendar: ['far', 'calendar'],
  farCamera: ['far', 'camera'],
  farCameraRetro: ['far', 'camera-retro'],
  farCartShopping: ['far', 'cart-shopping'],
  farCircleHeart: ['far', 'circle-heart'],
  farCircleInfo: ['far', 'circle-info'],
  farSchool: ['far', 'school'],
  farSquare: ['far', 'square'],
  farTableList: ['far', 'table-list'],
  farTriangleExclamation: ['far', 'triangle-exclamation'],
  farUser: ['far', 'user']
}

/** Resolves a CMS icon slug (e.g. `'farSchool'`) to a FontAwesome icon array. */
export function resolveIcon(slug: string): string[] {
  return iconIds[slug as keyof typeof iconIds] ?? []
}

export function initIconLibrary() {
  library.add(
    farCalendar,
    farCamera,
    farCameraRetro,
    farCartShopping,
    farCircleHeart,
    farCircleInfo,
    farCopy,
    farCircle,
    farCircleDot,
    farSchool,
    farSquare,
    farTableList,
    farUser,
    fa1,
    fa2,
    fa3,
    faArrowLeft,
    faArrowUpRightFromSquare,
    faBan,
    faBars,
    faCamera,
    faCalendarDays,
    faCheck,
    faCircle1,
    faCircle2,
    faCircle3,
    faCircle4,
    faCircle5,
    faCircleCheck,
    faCircleArrowDown,
    faCircleArrowLeft,
    faCircleArrowRight,
    faCircleArrowUp,
    faCircleExclamation,
    faDownload,
    faEye,
    faEyeSlash,
    faCirclePlay,
    faComment,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faChevronsDown,
    faChevronsUp,
    faChevronUp,
    faCircleInfo,
    faClock,
    faEnvelope,
    faGlobe,
    faGrid,
    faHeart,
    faHouse,
    faImage,
    faLocationDot,
    faLock,
    faMessage,
    faMinus,
    faPhone,
    faPlus,
    faPrint,
    faSparkles,
    faSpinner,
    faStar,
    faSquareCheck,
    faSquarePlus,
    faTimes,
    faTriangleExclamation,
    farTriangleExclamation,
    faUpload,
    faUser,
    faXmark
  )
}
